import { render, staticRenderFns } from "./ActiveDeliveryStepperPage.vue?vue&type=template&id=822d339c&"
import script from "./ActiveDeliveryStepperPage.vue?vue&type=script&lang=js&"
export * from "./ActiveDeliveryStepperPage.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDeliveryStepperPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports